<template>
  <div id="courses">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-banner">
          <img src="../../../public/images/首屏大banner@2x.png" />
          <div class="swiper-slide-title" style="text-align: center;">
            <div style="font-size: 40px;">AI 课程深度学习学院</div>
            <div style="font-size: 16px;margin-top:20px">
              NVIDIA DLI 培训 | NVIDIA DLI课程 | NVIDIA 证书
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text common">
      <el-row class="text-top">
        <el-col>
          <div class="img-right-box">
            <img
              class="img-left"
              src="https://img.deepbaytech.com/images2021/deep.png"
            />
            <img
              class="img-right-in"
              src="https://img.deepbaytech.com/images2021/video_light_small.png"
              @click="show = true"
            />
          </div>
        </el-col>
        <el-col class="right">
          <p class="ai-deep">NVIDIA 深度学习学院 （DLI）</p>
          <p
            class="nvidia"
            style="  margin-bottom: 40px;
"
          >
            NVIDIA 深度学习学院 (DLI) 提供 AI
            、加速计算和加速数据科学的应用开发实战培训。基于云端完全配置的 GPU
            平台，开发者、数据科学家、研究人员和院校师生可以快速获取端到端应用开发经验和提升专业技能。IT
            专业人员可以学习设计和管理基础架构，支持企业的
            AI、数据科学和高性能计算 (HPC) 工作负载。同时获得全球通行的 NVIDIA
            DLI 培训证书，为您的能力和职业发展提供有力证明。 深湾科技作为NVIDIA
            正式授权之深度学习学院(DLI)合作伙伴，共同推出DLI
            培训，展开AI人工智能人才培训，支持您的专业职涯成长
          </p>
          <div class="wacth">
            <i class="arrow"></i
            ><span style="font-size: 20px;color: #77BA00;line-height: 28px;"
              >观看视频，一分钟了解 DLI 培训</span
            >
          </div>
        </el-col>
      </el-row>
      <el-row class="text-bottom">
        <el-col class="left">
          <p class="ai-deep">将培训班引入您的企业机构或大型会议</p>
          <p class="nvidia">
            希望为您的员工、协会成员或客户安排专属的实战培训？
          </p>
          <a style="margin-top: 40px;" class="tab-programme-a" @click="hClick"
            >培训咨询</a
          >
        </el-col>
        <el-col>
          <div>
            <img
              class="img-right"
              src="https://img.deepbaytech.com/images2021/training.png"
            />
          </div>
          <div v-if="show" class="box">
            <div class="icon" @click="show = false">
              <span class="span">
                <i class="el-icon-close"></i>
              </span>
            </div>
            <div class="video">
              <video
                style="width: 100%;height: 100%"
                src="https://images.nvidia.cn/cn/dli/training/DLI-Social_promotion_video_cn.mp4"
                autoplay
                controls
                muted
              ></video>
            </div>
          </div>
        </el-col>
      </el-row>
      <!--弹框-->
      <el-dialog
        :lock-scroll="false"
        v-if="dialogVisible"
        title="服务咨询"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="hClose"
      >
        <el-form
          class="dialog"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          :label-position="labelPosition"
        >
          <el-form-item label="联系人：" prop="username">
            <el-input
              v-model.trim="ruleForm.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input
              v-model.number="ruleForm.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input
              v-model.trim="ruleForm.email"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称：" prop="companyName">
            <el-input
              v-model.trim="ruleForm.companyName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在地：" prop="companyAddr">
            <el-input
              v-model.trim="ruleForm.companyAddr"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="问题描述：" prop="question">
            <el-input
              type="textarea"
              placeholder="请输入"
              v-model.trim="ruleForm.question"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose" size="small">取 消</el-button>
          <el-button type="success" @click="submitForm" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!--  选择 NVIDIA DLI 培训-->
    <div class="choose">
      <div class="choose-in">
        <p
          style="
font-size: 28px;color: #333333;line-height: 40px;text-align: center;margin-bottom: 60px;"
        >
          为何选择 NVIDIA DLI 培训?
        </p>
        <div class="choose-container">
          <div class="choose-item">
            <div class="choose-img">
              <img src="https://img.deepbaytech.com/images2021/DLI.png" />
            </div>
            <p class="choose-item-title">DLI 认证讲师</p>
            <p class="choose-item-text">
              讲师为经过 DLI
              认证的个领域专家。无论线上或线下培训，学员都可以与讲师充分答疑互动。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/acquire_expertise.png"
              />
            </div>
            <p class="choose-item-title">获取专业技能</p>
            <p class="choose-item-text">
              跟随行业技术专家，学习聚焦当下新技术的课程，快速获取开发技能和经验。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/tools_frameworks.png"
              />
            </div>
            <p class="choose-item-title">行业标准的工具和框架</p>
            <p class="choose-item-text">
              利用被广泛应用的、符合行业标准的软件、工具和框架，获取可复制的经验。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/industry_application.png"
              />
            </div>
            <p class="choose-item-title">广泛行业应用</p>
            <p class="choose-item-text">
              学习构建适用机器人、自动驾驶、制造、金融和医疗等行业的深度学习、加速计算和加速数据科学应用。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/training_certificate.png"
              />
            </div>
            <p class="choose-item-title">培训证书</p>
            <p class="choose-item-text">
              讲师为经过 DLI
              认证的个领域专家。无论线上或线下培训，学员都可以与讲师充分答疑互动。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/application_scenarios.png"
              />
            </div>
            <p class="choose-item-title">真实应用场景</p>
            <p class="choose-item-text">
              跟随行业技术专家，学习聚焦当下新技术的课程，快速获取开发技能和经验。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/development_environment.png"
              />
            </div>
            <p class="choose-item-title">实时 GPU 开发环境</p>
            <p class="choose-item-text">
              利用被广泛应用的、符合行业标准的软件、工具和框架，获取可复制的经验。
            </p>
          </div>
          <div class="choose-item">
            <div class="choose-img">
              <img
                src="https://img.deepbaytech.com/images2021/production_time.png"
              />
            </div>
            <p class="choose-item-title">缩短生产时间</p>
            <p class="choose-item-text">
              学习构建适用机器人、自动驾驶、制造、金融和医疗等行业的深度学习、加速计算和加速数据科学应用。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 快速学习 -->
    <div class="text">
      <el-row class="text-top">
        <el-col>
          <div class="img-right-box">
            <img
              class="img-left"
              src="https://img.deepbaytech.com/images2021/fast_learning.png"
            />
          </div>
        </el-col>
        <el-col class="right">
          <p class="ai-deep">跟随专家导师，快速学习</p>
          <p
            class="nvidia"
            style="  margin-bottom: 40px;
"
          >
            如果您的组织机构希望快速发展或提升在
            AI、加速计算或加速数据科学方面的技能和经验，可以申请有讲师实时授课的培训班。所有讲师为经过
            DLI
            认证的各领域专家，将传授先进的技术和实践方案，引导学员在完全配置的
            GPU 服务器上亲自开发实战，和答疑解惑。学员将获得全球通行的 NVIDIA
            培训证书，并在课后继续回顾课件和实验环境
          </p>
        </el-col>
      </el-row>
      <el-row class="text-bottom">
        <el-col class="left">
          <p class="ai-deep">您希望自己的企业成为 AI 领跑者 ？</p>
          <p class="nvidia">
            根据您的企业的特定目标和学习需求，我们提供全面的 DLI
            培训服务，可以有效提高在
            AI、数据科学和加速计算领域的技能和经验，助力 AI
            应用场景落地，提升企业竞争力。
          </p>
        </el-col>
        <el-col>
          <div>
            <img
              class="img-right"
              src="https://img.deepbaytech.com/images2021/leader.png"
            />
          </div>
        </el-col>
      </el-row>
    </div>
    <Consultation class="common"></Consultation>
    <Footer class="common"></Footer>
  </div>
</template>

<script>
import Consultation from "./../../components/Consultation/Consultation";
import Footer from "../../components/Footer/Footer.vue";
import { getServiceConsultation } from "./../../api/index";
export default {
  name: "Courses",
  components: { Footer, Consultation },
  data() {
    return {
      show: false,
      dialogVisible: false,
      textarea: "",
      labelPosition: "left",
      ruleForm: {
        username: "",
        phone: "",
        email: "",
        companyName: "",
        companyAddr: "",
        question: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyAddr: [
          { required: true, message: "请输入所在地", trigger: "blur" },
        ],
        question: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.ruleForm = {};
    },
    hClose() {
      document.body.style.overflow = "auto";
    },
    hClick() {
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          getServiceConsultation(this.ruleForm).then(() => {
            alert("发送成功");
            this.dialogVisible = false;
            console.log(this.ruleForm);
          });
        } else {
          alert("请输入必填项");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide-banner img {
  width: 100%;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 0px;
}
.text-top {
  display: flex;
  height: 320px;
  width: 100%;
  max-width: 1180px;
  margin: 80px auto 0;
  align-items: center;
}
.img-left {
  width: 580px;
  height: 320px;
}
.right {
  width: 560px;
  margin-left: 40px;
}
.ai-deep {
  color: #333;
  font-size: 24px;
  line-height: 33px;
  font-weight: 400;
}
.nvidia {
  width: 560px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  margin-top: 20px;
}
.text-bottom {
  display: flex;
  height: 320px;
  width: 100%;
  max-width: 1180px;
  margin: 80px auto 60px;
  align-items: center;
}
.left {
  width: 560px;
}
.img-right-box {
  position: relative;
}
.img-right {
  width: 580px;
  height: 320px;
  margin-left: 40px;
}
.img-right-in {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 24px;
  bottom: 24px;
  opacity: 1;
}
.box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  overflow: hidden;
  z-index: 9999;
}
.icon {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 30%;
  left: 73%;
  /* -webkit-transform: translate(-50%); */
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.3);
  /* -webkit-box-shadow: 0 0 5px rgb(0 0 0 / 40%); */
  box-shadow: 0 0 5px rgb(0 0 0 / 10%);
  border-radius: 50%;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
}
.span {
  font-family: element-icons !important;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
.video {
  width: 800px;
  height: 600px;
  position: absolute;
  left: 50%;
  top: 50%;
  /* -webkit-transform: translate(-50%, -50%); */
  transform: translate(-50%, -50%);
}
.wacth {
  display: flex;
  align-items: center;
}
.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-right: 12px solid #77ba00;
  margin-right: 8px;
}
.choose {
  background: #f6f8fb;
  padding: 60px 0;
}
.choose-in {
  width: 1180px;
  margin: auto;
}
.choose-container {
  display: flex;
  flex-wrap: wrap;
}
.choose-img {
  text-align: center;
}
.choose-item {
  margin-right: 52px;
  margin-bottom: 40px;
}
.choose-item:nth-child(4n) {
  margin-right: 0px;
}
.choose-item img {
  width: 100px;
  height: 100px;
}
.choose-item-title {
  text-align: center;
  line-height: 22px;
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin: 20px 0 12px 0;
}
.choose-item-text {
  width: 248px;
  line-height: 20px;
  color: #666666;
  font-size: 14px;
}
.dialog {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px 24px 0 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-textarea__inner {
  height: 144px;
  border-radius: 0;
  padding-left: 12px;
}
::v-deep .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-input__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-dialog__footer {
  padding: 15px 24px 15px 0;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
::v-deep .el-input__inner {
  width: 240px;
  height: 32px;
  border-radius: 0%;
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
.el-button--success:hover {
  background-color: #77ba00;
}
.el-button--default:hover {
  background-color: #fff;
  color: #666666;
  border: 1px solid #dddddd;
}
#courses ::v-deep .el-dialog {
  min-width: 570px;
  margin: 0 auto 0px;
}
.tab-programme-a {
  display: inline-block;
  width: 120px;
  height: 40px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  background: #77ba00;
  text-decoration: none;
  margin-top: 78px;
  cursor: pointer;
}
</style>
